import {Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {User} from 'projects/core/src/lib/login/data/user';
import {TimeCard, TimeCardType} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card';
import moment from 'moment';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {TimeCardService} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {VacationDaysService} from '../data/vacation-days.service';
import {VacationEventsStore} from '../data/vacation-events.store';
import {VacationEventsQuery} from '../data/vacation-events.query';
import {DeviceDetectorService} from 'ngx-device-detector';
import {VacationStats} from 'projects/app-misc/src/app/modules/punch-time-widget/data/vacation-stats';
import {MiscSnackBarService} from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {OverlayPanel} from 'primeng/overlaypanel';
import * as jq from 'jquery';
import {VacationDay} from 'projects/desktop/src/app/modules/timesheets/view/vacation-calendar/data/vacation-day';

class VacationType {
  id: number;
  name: TimeCardType;
  title: string;
}

@Component({
  selector: 'app-vacation-day-dialog',
  templateUrl: './vacation-day-dialog.component.html',
  styleUrls: ['./vacation-day-dialog.component.scss'],
  providers: [
    VacationEventsStore,
    VacationDaysService,
    VacationEventsQuery,
    DeviceDetectorService
  ]
})
export class VacationDayDialogComponent implements OnInit, AfterViewInit {

  users: User[] = [];
  currentUser: User;
  selectedUser: User;

  timeCard: VacationDay;

  vacationTypes: VacationType[] = [{
    id: 0,
    name: 'VACATION',
    title: 'Vacation'
  }, {
    id: 1,
    name: 'SICK_HOURS',
    title: 'Sick day'
  }, {
    id: 2,
    name: 'UNPAID_VACATION',
    title: 'Unpaid Vacation'
  }]

  selectedVacation: VacationType;

  newTime: boolean;

  startDate: Date;

  dates: Date[];

  notes: string;

  buttonLabel: string;

  rejectLoadingSpinner = false;
  loadingSpinner = false;
  deleteLoadingSpinner = false;

  breakType: string;
  breakName: string;

  headerString: string;

  disableSaveButton = false;

  vacationStats: VacationStats;
  usedSickDays: number;

  rejected: boolean;

  overlayPanelMessage: string;

  editMode = false;
  editedSick: number;
  editedVacation: number;

  @ViewChild('vacationRejectPanel', {static: true})
  vacationRejectPanel: OverlayPanel

  @ViewChild('infoIconHover', {static: false})
  infoIconHover: ElementRef

  @ViewChild('timeOffInfoPanel', {static: true})
  timeOffInfoPanel: OverlayPanel

  constructor(
    protected dialogRef: MatDialogRef<VacationDayDialogComponent>,
    private snackBar: MatSnackBar,
    protected userService: UserService,
    protected timeCardService: TimeCardService,
    protected vacationDaysService: VacationDaysService,
    protected miscSnackBarService: MiscSnackBarService,
    protected el: ElementRef,
    protected appStateQuery: AppStateQuery,
    @Inject(MAT_DIALOG_DATA) public data: { timeCard: TimeCard, buttonLabel: string, type: string }
  ) {
    this.buttonLabel = data.buttonLabel

    this.selectedVacation = this.vacationTypes[0]
    if (data.type === 'VACATION') {
      this.headerString = 'Request PTO';
    } else if (data.type === 'SICK_HOURS') {
      this.headerString = 'Request PTO'
      this.selectedVacation = this.vacationTypes[1]
    } else if (data.type === 'UNPAID_VACATION') {
      this.headerString = 'Request Unpaid Days'
      this.selectedVacation = this.vacationTypes[2]
    } else {
      this.headerString = 'Vacation'
    }


    if (data.timeCard) {
      this.timeCard = data.timeCard
      this.selectedVacation = this.vacationTypes.find(type => type.name === this.timeCard.type)

      if (this.timeCard.rejected) {
        this.headerString = 'Rejected Vacation'
        this.rejected = true;
        this.overlayPanelMessage = this.timeCard.rejectReason ? this.timeCard.rejectReason : 'null'
      }
    }
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(user => this.currentUser = user);

    this.userService.getActiveUsers().subscribe(users => {
      this.users = users


      if (this.data.timeCard?.user?.id) {
        this.selectedUser = this.users.find(user => user.id === this.data.timeCard.user.id);
      } else {
        this.selectedUser = this.users.find(user => user.id === this.currentUser.id);
      }

      this.userChanged(this.selectedUser.id)

      if (this.timeCard) {
        this.newTime = false;
        this.startDate = moment(this.timeCard.startTime).toDate();
      }
    })
  }

  onUserChange(event: any) {
    if (event.value) {
      this.userChanged(event.value.id);
    }
  }

  calendarIsShown() {
    this.dialogRef.disableClose = true;
    this.blurActiveElement()
  }

  blurActiveElement() {
    setTimeout(() => {
      const activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }

  calendarIsClosed() {
    this.dialogRef.disableClose = false;
  }

  saveTimeButton() {
    this.loadingSpinner = true;
    if (this.buttonLabel === 'Request') {
      const datesArr = [];

      this.dates.forEach(date => {
        datesArr.push(moment(date).format('YYYY-MM-DD'))
      })

      let availableDays;

      if (this.selectedVacation.name === 'VACATION') {
        availableDays = Math.max(0, this.vacationStats.availableVacationDays)
      }

      if (this.selectedVacation.name === 'SICK_HOURS') {
        availableDays = Math.max(0, this.vacationStats.availableSickDays)
      }

      if (datesArr.length > availableDays) {
        this.miscSnackBarService.openWarningSnackBar('Not Enough Available Days')
        this.loadingSpinner = false;
        return;
      }

      this.vacationDaysService.requestVacationDay(this.selectedUser.id, datesArr.join(','), this.selectedVacation.name).subscribe(emit => {
        this.dialogRef.close('Success!');
      }, error => {
        this.loadingSpinner = false;
        this.miscSnackBarService.openErrorSnackBar(error.message)
      })
    } else {
      this.vacationDaysService.toggleVacationDay(this.timeCard.id + '').subscribe(emit => {
        this.dialogRef.close('Success!');
      }, error => {
        this.loadingSpinner = false;
        this.miscSnackBarService.openErrorSnackBar(error.message)
      })
    }
  }

  rejectTimeCard() {
    this.rejectLoadingSpinner = true;

    this.vacationDaysService.rejectVacationDay([this.timeCard.id]).subscribe(emit => {
      this.dialogRef.close('reject');
    }, error => {
      this.rejectLoadingSpinner = false;
      this.miscSnackBarService.openErrorSnackBar(error.message)
    })
  }

  userChanged(userId: number) {
    this.timeCardService.getAvailableDaysForUser(userId).subscribe(stat => {
      this.vacationStats = stat
    })
  }

  selectVacationType(type: VacationType) {
    if (this.buttonLabel === 'Request') {
      this.selectedVacation = type;
      this.updateHeaderString();
    }
  }

  updateHeaderString() {
    if (this.buttonLabel === 'Request') {
      if (this.selectedVacation.name === 'VACATION') {
        this.headerString = 'Request Vacation';
      } else if (this.selectedVacation.name === 'SICK_HOURS') {
        this.headerString = 'Request Sick Time';
      } else if (this.selectedVacation.name === 'UNPAID_VACATION') {
        this.headerString = 'Request Unpaid PTO';
      }
    }
  }

  getButtonLabel(): string {
    if (this.buttonLabel === 'Request') {
      if (this.selectedVacation.name === 'VACATION') {
        return 'Request Vacation';
      } else if (this.selectedVacation.name === 'SICK_HOURS') {
        return 'Request Sick Time';
      } else if (this.selectedVacation.name === 'UNPAID_VACATION') {
        return 'Request Unpaid PTO';
      }
    }
    return this.buttonLabel;
  }

  deleteTimeCard() {
    this.deleteLoadingSpinner = true;
    this.deleteTimeCardService();
  }

  deleteTimeCardService() {
    this.timeCardService.deleteTimeCard(this.timeCard.id).subscribe(event => {
        this.deleteLoadingSpinner = false;
        this.dialogRef.close(this.timeCard.id);
      },
      error => {
        this.deleteLoadingSpinner = false;
        if (error instanceof MvcExceptionResponse) {
          if (error.type === 'time_card.TimeCardException') {
            this.miscSnackBarService.openErrorSnackBar(error.message)
          }
        }
      })
  }

  ngAfterViewInit() {
    if (this.overlayPanelMessage) {
      const el = (this.el.nativeElement as HTMLElement).getElementsByClassName('reject-info-icon')[0]
      const shtEl = jq(el)
      // tslint:disable-next-line: deprecation
      shtEl.hover(jQEvent => {
        this.showHint(el)
      }, jQEvent => {
        this.hideHint()
      })
    }
  }

  showHint(el: Element) {
    this.vacationRejectPanel.show({}, el)
  }

  hideHint() {
    this.vacationRejectPanel.hide();
  }

  showTimeOffInfo(event: Event) {
    this.timeOffInfoPanel.toggle(event);
  }

  enableEditMode() {
    this.editMode = true;
    this.editedSick = this.vacationStats?.correctionSickDays;
    this.editedVacation = this.vacationStats?.correctionVacationDays;
  }

  cancelEditMode() {
    this.editMode = false;
    this.editedSick = this.vacationStats?.correctionSickDays;
    this.editedVacation = this.vacationStats?.correctionVacationDays;
  }

  saveVacationStats() {
    if (!this.selectedUser) {
      return;
    }

    const correctionSickDays = this.editedSick;
    const correctionVacationDays = this.editedVacation;

    this.timeCardService.updateUserVacationStats(this.selectedUser.id, correctionSickDays, correctionVacationDays).subscribe(() => {
      this.editMode = false;
      this.userChanged(this.selectedUser.id);
      this.miscSnackBarService.openSuccessSnackBar('Vacation stats updated successfully');
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message || 'Failed to update vacation stats');
    });
  }

}
